module.exports = __webpack_public_path__ + "static/media/footer-logo.d243b946.jpeg";